export const createCountdown = (durationInSeconds, onTick, onComplete) => {
	let remainingTime = durationInSeconds
	let timer = null

	const formatTime = (seconds) =>
		`${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`

	const start = () => {
		if (timer) return // Prevent multiple intervals
		onTick && onTick(formatTime(remainingTime))

		timer = setInterval(() => {
			if (remainingTime > 0) {
				remainingTime--
				onTick && onTick(formatTime(remainingTime))
			} else {
				pause()
				onComplete && onComplete()
			}
		}, 1000)
	}

	const pause = () => {
		clearInterval(timer)
		timer = null
	}

	// Reset the timer to a new duration
	const reset = (newDuration = durationInSeconds) => {
		pause()
		remainingTime = newDuration
		onTick && onTick(formatTime(remainingTime))
	}


	const complete = () => {
		pause()
		onComplete && onComplete()
	}

	return { start, pause, reset, complete }
}

// // How to use
// const timer = createCountdown(
// 	90,  // Start countdown from 1m 30s
// 	(formattedTime) => console.log(`Time left: ${formattedTime}`),
// 	() => console.log("⏳ Time's up!")
// )

// timer.start()   // Start countdown
// setTimeout(() => timer.pause(), 5000)   // Stop after 5s
// setTimeout(() => timer.start(), 7000)  // Resume after 7s
// setTimeout(() => timer.reset(150), 10000)  // Reset to 2m 30s after 10s